import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import AddPermissionModal from '../../modals/AddPermissionModal'
import SearchGroupsModal from '../../modals/SearchGroupsModal'
import SearchUsersModal from '../../modals/SearchUsersModal'
import { checkTranslation, getObject, imageAddress, translate } from '../../utils/useful'
import LoaderButton from '../LoaderButton'
import Responsive from '../Responsive'
import PermissionsView from '../PermissionsView'
import HttpServices from '../../utils/Http.services'


export default class PermissionsInput extends Component {

    state = {


    }

    componentDidMount() {

        setTimeout(() => {
            this.init()
        }, 20);

    }

    componentDidUpdate(prev) {

    }


    componentWillUnmount() {

    }



    init = () => {

        // console.log(this.props.variables)

        let body = this.props.header?.information?.filter ?? {}

        for (const [key, value] of Object.entries(body)) {
            if (/\{\{(.*?)\}\}/.test(value)) {

                let baseValue = value.replace(/{/g, '').replace(/}/g, '')


                // console.log(baseValue)
                if (getObject(this.props.fullData, baseValue)) {
                    body[key] = getObject(this.props.fullData, baseValue)

                } else if (this.props.variables && this.props.variables[baseValue]) {
                    body[key] = this.props.variables[baseValue]
                } else {

                    delete body[key]
                }

            }
        }

        // console.log(this.props.fullData)

        console.log(body)
        // return


        HttpServices.request('getAutomationPermissions', body, (fetchResult, fetchError) => {

            console.log("fetchResult, fetchError", fetchResult, fetchError)
            if (fetchError) {
                return
            }

            let object = { admins: fetchResult.framesAccessInfo, frames: fetchResult.automation?.frames, roles: fetchResult.automation?.applet?.roles }

            // console.log(this.props.data)
            if (this.props.data) {
                object.admins = this.props.data
            }

            this.setState(object)

        })
    }



    setPermissionsObject = (permissionsObject, cb) => {

        console.log("setPermissionsObject", permissionsObject)
        this.setState({ permissionsObject }, () => {
            if (cb) {
                cb()
            }
        })

    }

    setAdmins = (admins, cb) => {

        this.setState({ admins }, () => {
            // let finalAdmins = JSON.parse(JSON.stringify(admins))

            // if (Array.isArray(finalAdmins)) {

            //     finalAdmins.forEach((mAdmin, i) => {
            //         let hubs = []
            //         if (Array.isArray(mAdmin.hubs)) {

            //             mAdmin.hubs.forEach(hub => {
            //                 hubs.push(hub?._id ?? hub)
            //             });

            //         }

            //         let groups = []
            //         if (Array.isArray(mAdmin.groups)) {

            //             mAdmin.groups.forEach(group => {
            //                 groups.push(group?._id ?? group)
            //             });

            //         }
            //         finalAdmins[i].hubs = hubs
            //         finalAdmins[i].groups = groups

            //     });

            // }
            console.log("admins", this.props.header.key, admins)


            this.props.changeValue(this.props.header.key, admins, this.props.extra)

            if (cb) {
                cb()
            }
        })

    }


    render() {
        return (
            <div className='w-100'>

                <PermissionsView frames={this.state.frames} width={this.props.width} admins={this.state.admins} setAdmins={this.setAdmins} permissionsObject={this.state.permissionsObject} setPermissionsObject={this.setPermissionsObject} type={'stage'} stage={this.props.initData} variables={this.props.variables} className={"p-0 mt-0"} />

            </div>
        )
    }
}
